import { Component } from 'react';
import { Navigate } from "react-router-dom";
import ControlForm from '../../components/ControlForm/ControlForm';

class ControlPage extends Component{

    render(){

        if (!this.props.userAuthStatus) {
            return <Navigate replace to="/login" />;
        } else {
            return(
                <ControlForm/>
            );
        }
    }
}

export default ControlPage;